<div class="container-fluid">
    <app-report reportId="salesDashboard" screen="DASHBOARDSALES"></app-report>
  </div>
